var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _c(
      "section",
      { staticClass: "modal-card-body" },
      [
        _vm.isVersionUpdate
          ? _c("div", { staticClass: "update-notice" }, [
              _c("p", { staticClass: "update-notice__title" }, [
                _vm._v("יש לנו מדיניות פרטיות מעודכנת")
              ]),
              _c("p", [
                _vm._v(
                  "חשוב לנו לעדכן אותך שמדיניות הפרטיות שלנו התעדכנה. יש לקרוא ולאשר את התנאים, בכדי להמשיך את השימוש במערכת."
                )
              ])
            ])
          : _vm._e(),
        _c(
          "b-field",
          [
            _c(
              "b-checkbox",
              {
                model: {
                  value: _vm.termsAccepted,
                  callback: function($$v) {
                    _vm.termsAccepted = $$v
                  },
                  expression: "termsAccepted"
                }
              },
              [
                _vm._v(" קראתי ואני מסכים ל"),
                _c("a", { attrs: { href: "/terms.html", target: "_blank" } }, [
                  _vm._v("תנאי השימוש")
                ])
              ]
            )
          ],
          1
        ),
        _c(
          "b-field",
          [
            _c(
              "b-checkbox",
              {
                model: {
                  value: _vm.privacyAccepted,
                  callback: function($$v) {
                    _vm.privacyAccepted = $$v
                  },
                  expression: "privacyAccepted"
                }
              },
              [
                _vm._v(" קראתי ואני מסכים ל"),
                _c(
                  "a",
                  { attrs: { href: "/privacy.html", target: "_blank" } },
                  [_vm._v("מדיניות הפרטיות")]
                )
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "footer",
      { staticClass: "modal-card-foot" },
      [
        _c(
          "b-button",
          {
            attrs: {
              type: "is-primary",
              disabled: !_vm.termsAccepted || !_vm.privacyAccepted,
              loading: _vm.isLoading
            },
            on: { click: _vm.confirm }
          },
          [_vm._v(" אישור והמשך ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v("אישור תנאי שימוש ומדיניות פרטיות")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }